import { render, staticRenderFns } from "./ColumnData.vue?vue&type=template&id=2d030108&scoped=true&"
import script from "./ColumnData.vue?vue&type=script&lang=js&"
export * from "./ColumnData.vue?vue&type=script&lang=js&"
import style0 from "./ColumnData.vue?vue&type=style&index=0&id=2d030108&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d030108",
  null
  
)

export default component.exports